import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EmitCollapsibleExpandInterface } from '../interfaces/emit-collapsible-expand.interface';

@Injectable({
  providedIn: 'root'
})
export class CollapsibleService {
  private expandSubject = new Subject<EmitCollapsibleExpandInterface>();
  public expandObservable: Observable<EmitCollapsibleExpandInterface>;

  constructor() {
    this.expandObservable = this.expandSubject.asObservable();
  }

  public emitExpand(value: EmitCollapsibleExpandInterface) {
    this.expandSubject.next(value);
  }
}
